import React, { useEffect, useState } from "react";
import { getMaterials, deleteMaterial } from "../../../api/materialService";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../../utils/errorHandler";
import FullPageLoader from "../../../common/FullPageLoader";
import StatusBadge from "../../Shared/StatusBadge";
import ActionIconButton from "../../Shared/ActionIconButton";
import EmptyState from "../../../common/EmptyState";

export default function MaterialList() {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");
  const navigate = useNavigate();

  const fetchMaterials = async () => {
    try {
      setLoading(true);

      const response = await getMaterials({ search, sort });
      setMaterials(response?.data || response?.materials || []);
    } catch (error) {
      console.error("Error fetching materials:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaterials();
  }, [search, sort]);

  const handleDelete = async (id) => {
    try {
      await deleteMaterial(id);

      fetchMaterials();
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4 np-material-options-page">
      {loading && <FullPageLoader text="Loading materials..." />}
      <div className="card p-3">
        {materials.length === 0 && !loading ? (
          <EmptyState
            action={
              <button
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => navigate("/material/add")}
              >
                <FaPlus /> Add Material
              </button>
            }
          />
        ) : (
          <>
        <div className="d-flex align-items-center  justify-content-end pb-3 gap-2">
          <input
            type="text"
            className="form-control"
            style={{ width: "220px" }}
            placeholder="Search material..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          
          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/material/add")}
          >
            <FaPlus />
            Add Material
          </button>
        </div>

        {loading ? (
          <div className="text-center py-3">Loading...</div>
        ) : (
          <table className="table table-bordered table-hover">
            <thead className="bg-white">
              <tr>
                <th className="text-dark fw-bold">#</th>
                <th className="text-dark fw-bold">Material Name</th>
                <th className="text-dark fw-bold">Material Value</th>
                <th className="text-dark fw-bold">Status</th>
                <th className="text-dark fw-bold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {materials.length > 0 ? (
                materials.map((material, index) => (
                  <tr key={material._id}>
                    <td>{index + 1}</td>

                    <td>{material.name}</td>

                    <td>{material.value}</td>

                    <td>
                      <StatusBadge status={material.status} />
                    </td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center">
                      <ActionIconButton
                          icon={<FaEye />}
                          label="View"
                          variant="view"
                        onClick={() =>
                          navigate(`/material/view/${material.name}`, {
                            state: { materialId: material._id },
                          })
                        }
                      />

                      <ActionIconButton
                          icon={<FaEdit />}
                          label="Edit"
                          variant="edit"
                        onClick={() =>
                          navigate(`/material/edit/${material.name}`, {
                            state: { materialId: material._id },
                          })
                        }
                      />

                      <ActionIconButton
                          icon={<FaTrash />}
                          label="Delete"
                          variant="delete"
                        onClick={() => handleDelete(material._id)}
                      />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr />
              )}
            </tbody>
          </table>
        )}
          </>
        )}
      </div>
    </div>
  );
}
